export default __webpack_public_path__ + "static/media/icon-tick-white.954140d9.svg";